export enum RouteNames {
  profile = "profile",
  monthlydays = "monthlydays",
  drinkFrequency = "drinkfrequency",
  nonDrinkResults = "nondrinkresults",
  daysOfWeek = "daysofweek",
  averageDay = "averageday",
  singleOccasion = "singleoccasion",
  drinksPerWeekDay = "drinksperweekday",
  welcome = "welcome",
  drinkerResultsWeekly = "drinkerresultsweekly",
  drinkerResultsMonthly = "drinkerresultsmonthly"
}

export type RouteIndexer<T> = {
  [id in RouteNames]: T;
};
